// extracted by mini-css-extract-plugin
export default {"section":"TicketDetailsSection_section__Kqbr2","ticketsList":"TicketDetailsSection_ticketsList__G2WtA","emptyState":"TicketDetailsSection_emptyState__K5Rrl"};